module.exports = __webpack_public_path__ + "static/media/instrument1.6d47d97c.jpg";